document.addEventListener('DOMContentLoaded', function () {
    const mapContainers = document.querySelectorAll('.map-with-pin');

    if (!mapContainers || mapContainers.length === 0) {
        return false; // not on this page
    }

    mapContainers.forEach(container => {
        const mapBounds = {
            north: parseFloat(container.dataset.north),
            south: parseFloat(container.dataset.south),
            east: parseFloat(container.dataset.east),
            west: parseFloat(container.dataset.west)
        };

        const pinLat = parseFloat(container.dataset.pinLat);
        const pinLong = parseFloat(container.dataset.pinLong);
        const pinTitle = container.dataset.pinTitle || '';

        const mapImg = container.dataset.mapImg;
        const pinImg = container.dataset.pinImg;
        const mapElement = container.querySelector('.map-with-pin__container');

        if (mapImg) {
            mapElement.style.backgroundImage = `url('${mapImg}')`;
        }

        if (!isNaN(pinLat) && !isNaN(pinLong)) {
            addPin(mapElement, mapBounds, pinLat, pinLong, pinTitle, pinImg);
        }
    });

    function addPin(mapElement, mapBounds, latitude, longitude, title = '', pinImg = '') {
        const x = ((longitude - mapBounds.west) / (mapBounds.east - mapBounds.west)) * 100;
        const y = ((mapBounds.north - latitude) / (mapBounds.north - mapBounds.south)) * 100;

        const pin = document.createElement('div');
        pin.className = 'map-with-pin__marker';
        pin.title = title;
        pin.style.left = `${x}%`;
        pin.style.top = `${y}%`;

        const img = document.createElement('img');
        img.src = pinImg;
        img.alt = title || 'Map Pin';
        img.className = 'map-with-pin__marker-image';

        pin.appendChild(img);
        mapElement.appendChild(pin);

        return pin;
    }

    return true;
});
